import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

class Login extends Component {
 
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:''
        };

        this.handleSubmit = this.handleSubmit.bind(this); 
    }

    componentDidMount(){
        var loaderElement = document.querySelector('#load_screen');
        setTimeout( function() {
            loaderElement.style.display = "none";
        }, 3000); 
    }

    updateUsername(event){
        this.setState({username:event.target.value})
        console.log(this.state.username);

    }

    updatePassword(event){
         
        this.setState({password:event.target.value})
        console.log(this.state.password);

    }
    handleSubmit(event) {
        if(this.state.password.length > 0 && this.state.username.length>0){
            var loginDetails = new FormData();
            loginDetails.append('email', this.state.username);
            loginDetails.append('password', this.state.password);
            loginDetails.append('OP', 'loginUser');
            axios.post('http://sktrading.biz/BMSCalls/users.php',loginDetails)
              .then(function (response) {
                console.log("LOGIN",response.data);
                if(response.data.status =='true'){
                  localStorage.setItem("isAuth","true")
                  localStorage.setItem("NAME",response.data.response[0]['name'])
                  localStorage.setItem("EMAIL",response.data.response[0]['email'])
                  localStorage.setItem("ROLE",response.data.response[0]['role'])
                  localStorage.setItem("USERID",response.data.response[0]['id'])
                    toast.success('Logging In', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                        if(response.data.response[0]['role']=="Admin"){
                          window.location.pathname = '/dashboard'
                        }else{
                          window.location.pathname = '/add-bids'
                        }
                      //  window.location.pathname = '/AddBids'
                }else{
                    toast.error(response.data.response, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                     //   window.location.pathname = '/dashboard'
                  }
              })
              .catch(function (error) {
               // window.location.pathname = '/dashboard'
                console.log(error);
              });
        }else{
            toast.error("Insufficient Details", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                closeButton:false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }
      
          
        event.preventDefault();
      }
    
    render (){
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;

        return (
            
            <div>           
            {/* BEGIN LOADER */}
            <div id="load_screen"> <div className="loader"> <div className="loader-content">
                  <div className="spinner-grow align-self-center" />
            </div></div></div>
            {/*  END LOADER */}
            <div className="form-container outer">
              <div className="form-form">
                <div className="form-form-wrap">
                  <div className="form-container">
                    <div className="form-content">
                      <h1 id="login_string" className>Sign In</h1>
                      <p className>Log in to your account to continue</p>
                      <form id="user_login" className="text-left" onSubmit={this.handleSubmit}>
                        <div className="form">
                          <div id="username-field" className="field-wrapper input">
                            <label htmlFor="username">USERNAME</label>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx={12} cy={7} r={4} /></svg>
                            <input id="username" name="username" type="text" className="form-control" placeholder="user name"  value={this.state.username}  onChange={(e) => {this.updateUsername(e)}}  />
                          </div>
                          <div id="password-field" className="field-wrapper input mb-2">
                            <div className="d-flex justify-content-between">
                              <label htmlFor="password">PASSWORD</label>
                              <a href="auth_pass_recovery_boxed.html" className="forgot-pass-link">Forgot Password?</a>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-lock"><rect x={3} y={11} width={18} height={11} rx={2} ry={2} /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                            <input id="password" name="password" type="password" className="form-control" placeholder="Password" value={this.state.password}  onChange={(e) => {this.updatePassword(e)}} />
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" id="toggle-password" className="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx={12} cy={12} r={3} /></svg>
                          </div>
                          <div className="d-sm-flex justify-content-between">
                            <div className="field-wrapper">
                              <button type="submit" id="btnLogin" className="btn btn-primary"    value>Log In</button>
                              <ToastContainer />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
            {/* END GLOBAL MANDATORY SCRIPTS */}
          </div>
        )
    }
}
const mapStateToProps = (state) => ({
 
})
 
export default Login; 